import { Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../../services/auth.service";

// At least 8 characters with one uppercase letter, one number and one special
// character. The backend checks the same rules.
const PASSWORD_PATTERN = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9\s]).{8,}$/;

@Component({
  selector: "app-change-password-dialog",
  templateUrl: "./change-password-dialog.component.html",
  styleUrls: ["./change-password-dialog.component.scss"],
})
export class ChangePasswordDialogComponent {
  form = new FormGroup({
    old_password: new FormControl(""),
    new_password: new FormControl(""),
    confirm_password: new FormControl(""),
  });
  show = {
    old_password: false,
    new_password: false,
    confirm_password: false,
  };
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    private readonly authService: AuthService,
    private readonly toastr: ToastrService
  ) {}

  get canSubmit(): boolean {
    const { old_password, new_password, confirm_password } = this.form.value;
    return (
      !this.submitting &&
      !!old_password &&
      PASSWORD_PATTERN.test(new_password) &&
      new_password === confirm_password
    );
  }

  submit() {
    if (!this.canSubmit) {
      return;
    }
    this.submitting = true;
    this.authService.changePassword(this.form.value).subscribe(
      (res: any) => {
        this.toastr.success(res?.message);
        this.dialogRef.close(true);
      },
      // The interceptor shows the message sent by the backend
      () => (this.submitting = false)
    );
  }
}
